import React from "react";
import TopEducationLinks from "./00TopEducationLinks";
import './CryptoCurrency.css';
import LayoutMain from "../00LayoutMain/LayoutMain";
import TextChange from "../../../AdminPart/src/Elements/TextChange/TextChange";

function EducationCryptoCurrencySourceGatsby(props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} Active={5}>
            <main className="EducationCryptoCurrency StandartPage">
                <div className="StandartWhitePart">
                    <div className="StandartWhitePartTitle"><TextSource ArrIndex= 'EducationCryptoCurrency0020'>Обучающие статьи: Криптовалюта</TextSource> </div>
                <TopEducationLinks lang={props.lang}/>
                    {/*<iframe frameBorder={'0'}className="autoHeight-iframe"  title="EducationCryptoCurrency" name="EducationCryptoCurrency" src={'https://mtrader7.com/'+props.lang+'/iframe/pages/cryptocurrencies'} width="100%" height={'100%'} />*/}
                    <iframe frameBorder={'0'} className="autoHeight-iframe"  title="EducationCryptoCurrency" name="EducationCryptoCurrency"  src={"https://mtrader7.com/"+(props.lang === 'ru' ? '' : props.lang + '/')+"iframe/pages/cryptocurrencies"} width="100%" height={'100%'}/>

                </div>
        </main>
        </LayoutMain>

    )}

export default EducationCryptoCurrencySourceGatsby